import React from "react";

const ArrowAltIcon = ({ ...delegated }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...delegated}
    >
      <path d="M22.0781 16.76L16.9219 21.6819C16.6289 21.9456 16.1895 21.9456 15.9258 21.6526C15.6621 21.3596 15.6621 20.9202 15.9551 20.6565L19.8516 16.9358H9.89062C9.48047 16.9358 9.1875 16.6428 9.1875 16.2327C9.1875 15.8518 9.48047 15.5295 9.89062 15.5295H19.8516L15.9551 11.8381C15.6621 11.5745 15.6621 11.1057 15.9258 10.842C16.1895 10.5491 16.6582 10.5491 16.9219 10.8127L22.0781 15.7346C22.2246 15.8811 22.3125 16.0569 22.3125 16.2327C22.3125 16.4377 22.2246 16.6135 22.0781 16.76Z" />
    </svg>
  );
};

export { ArrowAltIcon };
